import Link from 'next/link';
import { AvatarWithFallback } from '@/components/shared/AvatarWithFallback';
import { UserPreview } from '@/components/shared/previews/UserPreview';
import { buildUserProfileRoute } from '@/lib/routes/app';
import type { TweetAuthor } from '@/types/tweet';

interface TweetAvatarProperties {
  author: TweetAuthor;
  linkToProfile?: boolean;
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg';
}

export function TweetAvatar({ author, size = 'md', linkToProfile = true }: TweetAvatarProperties) {
  const avatar = (
    <AvatarWithFallback
      src={author.profileImageUrl ?? null}
      alt={author.name}
      size={size}
      fallbackText={author.name?.[0] ?? '?'}
    />
  );

  if (!linkToProfile) {
    return avatar;
  }

  return (
    <UserPreview username={author.username}>
      <Link href={buildUserProfileRoute(author.username)} className="block">
        {avatar}
      </Link>
    </UserPreview>
  );
}
